import Carousel from 'react-bootstrap/Carousel';
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import AnimatedText from './animatedtext';
import '../css/campain.css';

import Ticker from '../components/ticker';

//import Campain1Image from '../images/campain/negativ-czarny-plaszcz-2026.webp';
import Campain1Image from '../images/campain/negativ-leather-jacket-and-red-catsuit-2026.webp';
import Campain2Image from '../images/campain/negativ-black-leather-skirt.webp';
//import Campain3Image from '../images/campain/negativ-trapery-2026.webp';
//import Campain4Image from '../images/campain/negativ-zlota-spinka.webp';

function useBreakpoint() {
  const getBreakpoint = () => {
    if (window.matchMedia("(max-width: 575px)").matches) return "mobile";
    if (window.matchMedia("(max-width: 991px)").matches) return "tablet";
    return "desktop";
  };

  const [breakpoint, setBreakpoint] = useState(getBreakpoint);

  useEffect(() => {
    const handler = () => setBreakpoint(getBreakpoint());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return breakpoint;
}

function chunkArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

function tryToOpenStore(url) {
    if (url.length > 0) {
        window.location.href = url;
    }
}

export default function CampainCarousel() {

    const breakpoint = useBreakpoint();
    const perSlide = { mobile: 1, tablet: 1, desktop: 2 }[breakpoint];
    const [index, setIndex] = useState(0);

    const params = useParams();

    const ITEMS = [
        { id: 1, image: Campain1Image, title: "Black leather coat from Negativ Brand 2026 collection", url: ""},
        { id: 2, image: Campain2Image, title: "Black leather jacket and red catsuit from Negativ Brand 2026 collection", url: `https://store.negativbrand.com/${params.lang}/product/28271845/show.html` },
        //{ id: 3, image: Campain3Image, title: "Black leather shoes from Negativ Brand 2026 collection", url: ""},
        //{ id: 4, image: Campain4Image, title: "Golden Negativ hair clip from Negativ Brand 2026 collection", url: `https://store.negativbrand.com/${params.lang}/product/28272131/show.html` }
    ]

    const slides = chunkArray(ITEMS, perSlide);
/* 
            karta z opisem
                    <img
                    src={item.image}
                    alt={item.title}
                    className="card-img-top"
                    style={{ aspectRatio: "4/3", objectFit: "cover" }}
                    />
                    <div className="card-body px-0 pt-2 pb-0">
                        <p className="card-title mb-0 fw-medium">{item.title}</p>
                        <p className="card-text text-muted small">{item.sub}</p>
                    </div>

                    albo  sam obrazek

                    <img
                        src={item.image}
                        alt={item.title}
                        className="rounded-2"
                        style={{ width: "100%", aspectRatio: "4/3", objectFit: "cover", display: "block" }}
                        />

                        fotki od dechy do dechy
                        <div className="d-flex">

                        fotki z przerwami
                        <div className="d-flex gap-3 px-5">
*/
    return (
        <>
        
        <div className="top-slogan">
            <AnimatedText text="Obviously <s>you could try</s>, but... nobody does it better than <s>Negativ!</s>" effect="typing" speed={25} startOnView={true} cursor={true} />
        </div>

        <Carousel interval={7000} indicators={false} controls={true} activeIndex={index} onSelect={setIndex} fade={true}>
        
            {slides.map((group, slideIndex) => (
                <Carousel.Item key={slideIndex}>

                    <div className="d-flex">
                        {group.map((item) => (
                        <div
                            key={item.id}
                            className="card border-1"
                            style={{ minWidth: 0, "--bs-card-bg": "#111", borderRadius: 4, "--bs-card-border-color": "#000", color: "#FFF" }}
                        >
                            
                            <img
                            src={item.image}
                            alt={item.title}
                            onClick={() => tryToOpenStore(item.url)}
                            className="card-img-top-campain"
                            />
                           
                        </div>
                        ))}
                    </div>
                    
                </Carousel.Item>
            ))}

        </Carousel>
        
        <Ticker />

        <div className="d-flex justify-content-center gap-2 mt-4">
            {slides.map((_, i) => (
            <button
                className="carousel-buttons"
                key={i}
                onClick={() => setIndex(i)}
                style={{
                width: i === index ? "5rem" : "1.5rem",
                height: "0.25rem",
                borderRadius: "0.1rem",
                border: i === index ? "1px solid #8b6736" : "1px solid #333",
                background: "#222",
                padding: 0,
                transition: "all 1s ease",
                }}
                aria-label={`Slajd ${i + 1}`}
            />
            ))}
        </div>
        </>
    )
}